import React from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import App from "./App";

const AppContainer = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route path={["/:language", "/"]} component={() => <App />} />
      </Switch>
    </BrowserRouter>
  );
};

export default AppContainer;
